import clonedeep from 'lodash.clonedeep'
import config from '../config'
import qz from '../printing/qz'
import { detectPrintLabelFormat } from '../printing/utils'
import { getFromStorage } from '../storage'
import { CurrentActions, CurrentActionTypes, CurrentState } from './types'

const currPrinter = getFromStorage('currentPrinter')
const currPrinterType = getFromStorage('currentPrinterType') || detectPrintLabelFormat(currPrinter)
const currHIDDevice = getFromStorage('currentHIDDevice') || {}
const currTestPrintType = getFromStorage('testPrintType') || 'barcode'

const BLANK_OPTIONS = {
  options: [],
  loading: false
}

const initialState: CurrentState = {
  ...clonedeep(config.current),
  currentPrinter: currPrinter,
  currentPrinterType: currPrinterType,
  testPrintType: currTestPrintType,
  currentHIDDevice: currHIDDevice,
  inventoryLocationOptions: BLANK_OPTIONS,
  qzConnection: {
    loading: true,
    connected: qz.websocket.isActive()
  },
  useFeature: {}
}

function CurrentReducer(state: CurrentState = initialState, action: CurrentActionTypes): CurrentState {
  switch (action.type) {
    case CurrentActions.SetFeature:
      // eslint-disable-next-line no-case-declarations
      const useFeature = { ...state.useFeature }
      useFeature[action.key] = action.value
      return {
        ...state,
        useFeature
      }
    case CurrentActions.EstablishQZConnection:
      return { ...state, qzConnection: { ...state.qzConnection, loading: true } }
    case CurrentActions.EstablishQZConnectionResult:
      return { ...state, qzConnection: { ...state.qzConnection, loading: false, connected: action.connected } }
    case CurrentActions.SetCurrentHIDDevice:
      return { ...state, currentHIDDevice: action.HIDDevice }
    case CurrentActions.SetCurrentPrinter:
      return {
        ...state,
        currentPrinter: action.printer
      }
    case CurrentActions.SetCurrentPrinterType:
      return {
        ...state,
        currentPrinterType: action.format
      }
    case CurrentActions.SetTestPrintType:
      return { ...state, testPrintType: action.testPrintType }
    case CurrentActions.SetOrganizationSettings:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            [action.key]: action.value
          }
        }
      }
    case CurrentActions.RequestOrganizationSettings:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            loading: true
          }
        }
      }
    case CurrentActions.RequestOrganizationSettingsSuccess:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            ...action.payload,
            loading: false
          }
        }
      }
    case CurrentActions.RequestOrganizationSettingsError:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            loading: false
          }
        }
      }
    case CurrentActions.SetProductLabelPrintSettings:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            printSettings: {
              ...state.organization.settings.printSettings,
              [action.key]: action.value
            }
          }
        }
      }

    case CurrentActions.RequestSetOrganizationSettings:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            loading: true
          }
        }
      }
    case CurrentActions.RequestSetOrganizationSettingsSuccess:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            ...action.payload,
            loading: false
          }
        }
      }
    case CurrentActions.RequestSetOrganizationSettingsError:
      return {
        ...state,
        organization: {
          ...state.organization,
          settings: {
            ...state.organization.settings,
            loading: false
          }
        }
      }
    case CurrentActions.RequestInventoryLocations:
      return {
        ...state,
        inventoryLocationOptions: {
          ...state.inventoryLocationOptions,
          error: undefined,
          loading: true
        }
      }
    case CurrentActions.RequestInventoryLocationsSuccess:
      return {
        ...state,
        inventoryLocationOptions: {
          values: action.values,
          loading: false
        }
      }
    case CurrentActions.RequestInventoryLocationsError:
      return {
        ...state,
        inventoryLocationOptions: {
          // don't destroy options we already have locally if the request fails
          ...state.inventoryLocationOptions,
          error: action.error,
          loading: false
        }
      }
    default:
      return state
  }
}

export default CurrentReducer
